export enum TourneyStatus {
  OPEN = 'open',
  CLOSE = 'close',
}
